// 首页列表组件
import * as React from 'react'
import HomeType from '../../../Home/types/HomeType'
import HomeItemTag from './HomeItemTag'
import * as Styles from './HomeItemListItem.style'
import {renderPopular} from '../../../../utils/tools'
import {classes} from 'typestyle'
// tslint:disable-next-line
const {LazyLoadImage} = require('react-lazy-load-image-component')

interface HomeLimitBarProp {
    content: HomeType.Content,
    topMargin?: number,
    bottomMargin?: number
}

export default class HomeItemListItem extends React.Component <HomeLimitBarProp> {
    public renderTitleTag() {
        const content = this.props.content
        if (content.type && content.type === 'lecture' && !content.is_preffered ) {
            this.renderLectureTag()
        } else {
            return
        }
    }
    public renderLectureTag() {
        const lecture = this.props.content
        if (lecture.lecture_mode === 'default') {
            switch (lecture.image_mode) {
                case 'video':
                    return <HomeItemTag text={'视频'}/>
                case 'audio':
                    return <HomeItemTag text={'音频'}/>
                case 'ppt':
                    return <HomeItemTag text={'PPT'}/>
                default:
                    return true
            }
        } else {
            switch (lecture.lecture_mode) {
                case 'video':
                    return <HomeItemTag text={'视频'}/>
                case 'audio':
                    return <HomeItemTag text={'音频'}/>
                default:
                    return true
            }
        }
    }
    public renderPrice() {
        const {content} = this.props
        if (content.stype === 'coupon') {
            return (
                <div className={Styles.couponTagSm}>
                    <div className={Styles.couponTagSmText}>立减{content.meta && content.meta.desc}元</div>
                </div>
            )
        }
        if (content.need_money) {
            if (content.has_limitmoney) {
                if (Number(content.limit_money) === 0) {
                    return <p><span>限时免费</span></p>
                } else {
                    // tslint:disable-next-line
                    return <p><i style={{fontStyle:'normal', fontSize: 12}}>￥</i>{content.limit_money.split('.')[0]}<span>.{content.limit_money.split('.')[1]}</span></p>
                }
            } else {
                // tslint:disable-next-line
                return <p><i style={{fontStyle:'normal', fontSize: 12}}>￥</i>{content.lecture_money.split('.')[0]}<span>.{content.lecture_money.split('.')[1]}</span></p>
            }
        } else {
            if (content.lecture_type !== 'pay_channel') {
                return <span className={Styles.HomeItemRightFreeLecture}>免费</span>
            } else {
                return null
            }
        }
    }

    public renderLectureTime() {
        const lecture = this.props.content

        if (lecture.lecture_mode === 'video' || lecture.lecture_mode === 'audio') {
            return (
                <p>时长<span>{lecture.audio_length}</span>分钟</p>
            )
        }

        if (lecture.status === 'closed') {
            if (lecture.audio_length <= 5) {
                return (
                    <p>{lecture.start_time.split(' ')[0]}</p>
                )
            } else {
                return (
                    <p>时长<span>{lecture.audio_length}</span>分钟</p>
                )
            }
        } else {
            return (
                <p>{lecture.status_name}</p>
            )
        }
    }

    public ifIsLivingStatus() {
        const content = this.props.content
        if (content.start_name === '正在直播') {
            return true
        } else {
            return false
        }
    }

    public render() {
        const {content} = this.props
        const getDistance = {
            paddingTop: this.props.topMargin ? this.props.topMargin : '',
            paddingBottom: this.props.bottomMargin ? this.props.bottomMargin : ''
        }
        return (
            <a style={getDistance} className={Styles.HomeItemListItem} href={content.stype === 'coupon' ? content.url + `&${content.meta.params}` : content.url}>
                <div className={Styles.HomeItemLeft}>
                    <div className={Styles.HomeItemLeftBgImage}>
                        <LazyLoadImage
                            width="100%"
                            alt={content.cover_url ? content.cover_url : content.cover}
                            effect="blur"
                            src={content.cover_url ? content.cover_url : content.cover}
                        />
                        {/*<img src={content.cover_url ? content.cover_url : content.cover} alt=""/>*/}
                    </div>
                    <div className={Styles.StudyTotalNum}>
                        <div className={Styles.StudyTotalNumDiv}>
                            <img src="https://static-1253442168.image.myqcloud.com/picture/10490565_5ddfe21b03842fa68973218ec2737646.jpg" alt=""/>
                            {renderPopular(content.popular)}人
                        </div>
                    </div>
                    {
                            content.stype === 'coupon' && (
                                <div>
                                    <div className={Styles.couponTagBig}/>
                                    <div className={Styles.couponTagBigText}>
                                        <p>立减</p>
                                        <p><span>{content.meta && content.meta.desc}</span></p>
                                    </div>
                                </div>
                            )
                        }
                </div>

                <div className={Styles.HomeItemRight}>
                    <div className={classes(Styles.HomeItemRightTitle, 'TextChangeToTwoLines')}>
                        {content.is_preffered && (
                            <div className={Styles.youXuanType}>
                                <img src="https://static-1253442168.image.myqcloud.com/picture/10490565_2851c8d7884e28dd13a5119f3f0afe89.jpg" alt=""/>
                            </div>)
                        }
                        {content.type && content.type === 'lecture' && !content.is_preffered &&
                            this.renderLectureTag()
                        }
                        {content.name ? content.name : content.title}
                    </div>

                    <div className={Styles.HomeItemLeftBottom}>
                        <div className="currency-item-right-bottom_left-count-time" style={{color: '#999999'}}>
                            {content.type && content.type === 'channel' && !this.ifIsLivingStatus() &&
                                <p>已更新<span>{content.current_status_display.replace('已更新', '').replace('期', '').replace('节课程', '').replace('含', '')}</span>期</p>
                            }
                            {(content.type && content.type === 'lecture') && !this.ifIsLivingStatus() &&
                                this.renderLectureTime()
                            }
                            {this.ifIsLivingStatus() &&
                            <div className="HomeItemLeftBottom">
                                <div className={Styles.isLivingText}>
                                    <img className={Styles.LiveStatusImg} src="https://static-1253442168.image.myqcloud.com/picture/7931794_e27bd04f8061e533ae1851e0928b2f50.jpg" alt=""/>
                                正在直播
                                </div>
                            </div>
                            }
                        </div>

                    <div className={Styles.HomeItemRightBotton}>
                        {(content.type && content.type === 'lecture') &&
                                <div className={Styles.HomeItemRightBottonRight}>
                                    {content.has_limitmoney && Number(content.limit_money) > 0 && content.stype !== 'coupon' &&
                                    <p className="HomeItemRightBottonRightLimit"><del>￥{content.lecture_money}</del></p>
                                    }
                                    {this.renderPrice()}
                                </div>
                                }
                                {content.type && content.type === 'channel' &&
                                <div className={Styles.HomeItemRightBottonRight}>
                                    {content.has_limitmoney && Number(content.limit_money) > 0 && content.stype !== 'coupon' &&
                                    <p className="HomeItemRightBottonRightLimit"><del>￥{content.lecture_money}</del></p>
                                    }
                                    {this.renderPrice()}
                                </div>
                            }
                    </div>
                    </div>
                </div>
            </a>
        )
    }
}



// WEBPACK FOOTER //
// ./src/views/Category/components/CategoryRecommendLectureItemList/HomeItemListItem.tsx